import React, { Suspense, useState, useEffect, useRef } from 'react'
import { Canvas, extend } from '@react-three/fiber'
import { Environment, OrbitControls, Sky } from '@react-three/drei'
import Scene from './Scene'
import * as THREE from 'three'
import './ContactForm.css'

export default function App() { 
  useEffect(() => {
      const setVh = () => {
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
      };

      window.addEventListener('resize', setVh);
      setVh(); // Initial call

      return () => {
          window.removeEventListener('resize', setVh);
      };
  }, []);
  
  const [activeMenu, setActiveMenu] = useState(window.innerWidth < 900 ? 1 : 0);

  useEffect(() => {
    const handleResize = () => {
      setActiveMenu(window.innerWidth < 900 ? 1 : 0);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const [activePanel, setActivePanel] = useState(0)
  const [isHovered, setIsHovered] = useState(0); 
  const [background, setBacground] = useState(1)
  
  const [color1, setColor1] = useState(() => {
    return localStorage.getItem('color1') || '#D7D5CB';
  });

  const [color2, setColor2] = useState(() => {
    return localStorage.getItem('color2') || '#0E0E10';
  });

  const [color3, setColor3] = useState(() => {
    return localStorage.getItem('color3') || '#0089B6';
  });

  const [color4, setColor4] = useState(() => {
    return localStorage.getItem('color4') || '#F1F0EA';
  });

  const [color5, setColor5] = useState(() => {
    return localStorage.getItem('color5') || '#0089B6';
  });

  const [color6, setColor6] = useState(() => {
    return localStorage.getItem('color6') || '#0E0E10';
  });

  const [color7, setColor7] = useState(() => {
    return localStorage.getItem('color7') || '#9e7c59';
  });

  const [fridge, setFridge] = useState(() => {
    return localStorage.getItem('fridge') ? parseInt(localStorage.getItem('fridge')) : 0;
  });

  const [backAdd, setBackAdd] = useState(() => {
    return localStorage.getItem('backAdd') ? parseInt(localStorage.getItem('backAdd')) : 0;
  });

  // Handle changes and update localStorage
  useEffect(() => {
    localStorage.setItem('activeMenu', activeMenu);
  }, [activeMenu]);

  useEffect(() => {
    localStorage.setItem('activePanel', activePanel);
  }, [activePanel]);

  useEffect(() => {
    localStorage.setItem('background', background);
  }, [background]);

  useEffect(() => {
    localStorage.setItem('color1', color1);
  }, [color1]);

  useEffect(() => {
    localStorage.setItem('color2', color2);
  }, [color2]);

  useEffect(() => {
    localStorage.setItem('color3', color3);
  }, [color3]);

  useEffect(() => {
    localStorage.setItem('color4', color4);
  }, [color4]);

  useEffect(() => {
    localStorage.setItem('color5', color5);
  }, [color5]);

  useEffect(() => {
    localStorage.setItem('color6', color6);
  }, [color6]);

  useEffect(() => {
    localStorage.setItem('color7', color7);
  }, [color7]);

  useEffect(() => {
    localStorage.setItem('fridge', fridge);
  }, [fridge]);

  useEffect(() => {
    localStorage.setItem('backAdd', backAdd);
  }, [backAdd]);

  const handleFridgeChange = (event) => {
    const value = event.target.checked ? 1 : 0;
    setFridge(value);
    localStorage.setItem('fridge', value);
  };

  const handleWaterSkiChange = (event) => {
    const value = event.target.checked ? 1 : 0;
    setBackAdd(value);
    localStorage.setItem('backAdd', value);
  };

  const handleTableChange = (event) => {
    const value = event.target.checked ? 2 : 0;
    setBackAdd(value);
    localStorage.setItem('backAdd', value);
  };
  const [form, setForm] = useState(0)


  const formRef = useRef();
  const [formData, setFormData] = useState({
    firstName: "",
    phoneNumber: "",
    country: "",
    email: "",
    message: "",
    attachment: null
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };


  return (
    <>
    <div className='main-container'>
      <div className='canvasDiv'>
        <Canvas 
          shadows
          camera={{ position: [0, 100, 200], fov: 55}}
          gl={{ antialias: true, alpha: true }} // Ensures antialiasing is set
          onCreated={({ gl }) => {
            gl.setPixelRatio(window.devicePixelRatio)
            gl.toneMapping = THREE.ACESFilmicToneMapping
            gl.outputEncoding = THREE.sRGBEncoding
          }}
          style ={{position: 'absolute', top: '0px', left: '0px', width: '100%', height: '100%'}}
        >
          
          <Suspense fallback={null} >
              <Scene 
                activePanel={activePanel} 
                background={background}
                color1={color1}
                color2={color2}
                color3={color3}
                color4={color4}
                color5={color5}
                color6={color6}
                color7={color7}
                fridge={fridge}
                backAdd={backAdd}
              />
          </Suspense>
          <group rotation={[0,Math.PI/2,0]}>
            <Sky scale={1000} sunPosition={[500, 150, -1000]} turbidity={0} />
          </group>
        </Canvas>
      </div>

      <div className='control-panel'>
        <div className='top-labels'>
          MOTOR YACHT
        </div>
        <div className='controls'>
          <div className='dropdown'>
            <div className='dropdown-top'>
              <div className='left-group'>
                <span style={{background:color1}}/>
                <div>
                  HULL TOP
                </div>
              </div>
              <img src={(activePanel === 1) ? 'at.png' : 'ad.png'} onClick={() => setActivePanel(activePanel !== 1 ? 1 : 0)}/>
            </div>
            <div className={`dropdown-items ${(activePanel === 1) ? 'active' : ''}`}>
              <button onClick={() => setColor1('#F1DD38')} style={{background:'#F1DD38'}} className={color1 === '#F1DD38' ? 'active' : ''}/>
              <button onClick={() => setColor1('#FFB200')} style={{background:'#FFB200'}} className={color1 === '#FFB200' ? 'active' : ''}/>
              <button onClick={() => setColor1('#FF4D06')} style={{background:'#FF4D06'}} className={color1 === '#FF4D06' ? 'FF4D06' : ''}/>
              <button onClick={() => setColor1('#FF2A1B')} style={{background:'#FF2A1B'}} className={color1 === '#FF2A1B' ? 'active' : ''}/>
              <button onClick={() => setColor1('#BC4077')} style={{background:'#BC4077'}} className={color1 === '#BC4077' ? 'active' : ''}/>
              <button onClick={() => setColor1('#903373')} style={{background:'#903373'}} className={color1 === '#903373' ? 'active' : ''}/>
              <button onClick={() => setColor1('#00B51A')} style={{background:'#00B51A'}} className={color1 === '#00B51A' ? 'active' : ''}/>
              <button onClick={() => setColor1('#7EBAB5')} style={{background:'#7EBAB5'}} className={color1 === '#7EBAB5' ? 'active' : ''}/>
              <button onClick={() => setColor1('#0089B6')} style={{background:'#0089B6'}} className={color1 === '#0089B6' ? 'active' : ''}/>
              <button onClick={() => setColor1('#6093AC')} style={{background:'#6093AC'}} className={color1 === '#6093AC' ? 'active' : ''}/>
              <button onClick={() => setColor1('#21697C')} style={{background:'#21697C'}} className={color1 === '#21697C' ? 'active' : ''}/>
              <button onClick={() => setColor1('#222D5A')} style={{background:'#222D5A'}} className={color1 === '#222D5A' ? 'active' : ''}/>
              <button onClick={() => setColor1('#0E0E10')} style={{background:'#0E0E10'}} className={color1 === '#0E0E10' ? 'active' : ''}/>
              <button onClick={() => setColor1('#2F3234')} style={{background:'#2F3234'}} className={color1 === '#2F3234' ? 'active' : ''}/>
              <button onClick={() => setColor1('#4F5358')} style={{background:'#4F5358'}} className={color1 === '#4F5358' ? 'active' : ''}/>
              <button onClick={() => setColor1('#8D9295')} style={{background:'#8D9295'}} className={color1 === '#8D9295' ? 'active' : ''}/>
              <button onClick={() => setColor1('#D7D5CB')} style={{background:'#D7D5CB'}} className={color1 === '#D7D5CB' ? 'active' : ''}/>
              <button onClick={() => setColor1('#F1F0EA')} style={{background:'#F1F0EA'}} className={color1 === '#F1F0EA' ? 'active' : ''}/>
            </div>
          </div>
          <div className='dropdown'>
            <div className='dropdown-top'>
              <div className='left-group'>
                <span style={{background:color2}}/>
                <div>
                  HULL BOTTOM
                </div>
              </div>
              <img src={(activePanel === 2) ? 'at.png' : 'ad.png'} onClick={() => setActivePanel(activePanel !== 2 ? 2 : 0)}/>
            </div>
            <div className={`dropdown-items ${(activePanel === 2) ? 'active' : ''}`}>
              <button onClick={() => setColor2('#F1DD38')} style={{background:'#F1DD38'}} className={color2 === '#F1DD38' ? 'active' : ''}/>
              <button onClick={() => setColor2('#FFB200')} style={{background:'#FFB200'}} className={color2 === '#FFB200' ? 'active' : ''}/>
              <button onClick={() => setColor2('#FF4D06')} style={{background:'#FF4D06'}} className={color2 === '#FF4D06' ? 'FF4D06' : ''}/>
              <button onClick={() => setColor2('#FF2A1B')} style={{background:'#FF2A1B'}} className={color2 === '#FF2A1B' ? 'active' : ''}/>
              <button onClick={() => setColor2('#BC4077')} style={{background:'#BC4077'}} className={color2 === '#BC4077' ? 'active' : ''}/>
              <button onClick={() => setColor2('#903373')} style={{background:'#903373'}} className={color2 === '#903373' ? 'active' : ''}/>
              <button onClick={() => setColor2('#00B51A')} style={{background:'#00B51A'}} className={color2 === '#00B51A' ? 'active' : ''}/>
              <button onClick={() => setColor2('#7EBAB5')} style={{background:'#7EBAB5'}} className={color2 === '#7EBAB5' ? 'active' : ''}/>
              <button onClick={() => setColor2('#0089B6')} style={{background:'#0089B6'}} className={color2 === '#0089B6' ? 'active' : ''}/>
              <button onClick={() => setColor2('#6093AC')} style={{background:'#6093AC'}} className={color2 === '#6093AC' ? 'active' : ''}/>
              <button onClick={() => setColor2('#21697C')} style={{background:'#21697C'}} className={color2 === '#21697C' ? 'active' : ''}/>
              <button onClick={() => setColor2('#222D5A')} style={{background:'#222D5A'}} className={color2 === '#222D5A' ? 'active' : ''}/>
              <button onClick={() => setColor2('#0E0E10')} style={{background:'#0E0E10'}} className={color2 === '#0E0E10' ? 'active' : ''}/>
              <button onClick={() => setColor2('#2F3234')} style={{background:'#2F3234'}} className={color2 === '#2F3234' ? 'active' : ''}/>
              <button onClick={() => setColor2('#4F5358')} style={{background:'#4F5358'}} className={color2 === '#4F5358' ? 'active' : ''}/>
              <button onClick={() => setColor2('#8D9295')} style={{background:'#8D9295'}} className={color2 === '#8D9295' ? 'active' : ''}/>
              <button onClick={() => setColor2('#D7D5CB')} style={{background:'#D7D5CB'}} className={color2 === '#D7D5CB' ? 'active' : ''}/>
              <button onClick={() => setColor2('#F1F0EA')} style={{background:'#F1F0EA'}} className={color2 === '#F1F0EA' ? 'active' : ''}/>
            </div>
          </div>
          <div className='dropdown'>
            <div className='dropdown-top'>
              <div className='left-group'>
                <span style={{background:color3}}/>
                <div>
                  HULL LINING
                </div>
              </div>
              <img src={(activePanel === 3) ? 'at.png' : 'ad.png'} onClick={() => setActivePanel(activePanel !== 3 ? 3 : 0)}/>
            </div>
            <div className={`dropdown-items ${(activePanel === 3) ? 'active' : ''}`}>
              <button onClick={() => setColor3('#F1DD38')} style={{background:'#F1DD38'}} className={color3 === '#F1DD38' ? 'active' : ''}/>
              <button onClick={() => setColor3('#FFB200')} style={{background:'#FFB200'}} className={color3 === '#FFB200' ? 'active' : ''}/>
              <button onClick={() => setColor3('#FF4D06')} style={{background:'#FF4D06'}} className={color3 === '#FF4D06' ? 'FF4D06' : ''}/>
              <button onClick={() => setColor3('#FF2A1B')} style={{background:'#FF2A1B'}} className={color3 === '#FF2A1B' ? 'active' : ''}/>
              <button onClick={() => setColor3('#BC4077')} style={{background:'#BC4077'}} className={color3 === '#BC4077' ? 'active' : ''}/>
              <button onClick={() => setColor3('#903373')} style={{background:'#903373'}} className={color3 === '#903373' ? 'active' : ''}/>
              <button onClick={() => setColor3('#00B51A')} style={{background:'#00B51A'}} className={color3 === '#00B51A' ? 'active' : ''}/>
              <button onClick={() => setColor3('#7EBAB5')} style={{background:'#7EBAB5'}} className={color3 === '#7EBAB5' ? 'active' : ''}/>
              <button onClick={() => setColor3('#0089B6')} style={{background:'#0089B6'}} className={color3 === '#0089B6' ? 'active' : ''}/>
              <button onClick={() => setColor3('#6093AC')} style={{background:'#6093AC'}} className={color3 === '#6093AC' ? 'active' : ''}/>
              <button onClick={() => setColor3('#21697C')} style={{background:'#21697C'}} className={color3 === '#21697C' ? 'active' : ''}/>
              <button onClick={() => setColor3('#222D5A')} style={{background:'#222D5A'}} className={color3 === '#222D5A' ? 'active' : ''}/>
              <button onClick={() => setColor3('#0E0E10')} style={{background:'#0E0E10'}} className={color3 === '#0E0E10' ? 'active' : ''}/>
              <button onClick={() => setColor3('#2F3234')} style={{background:'#2F3234'}} className={color3 === '#2F3234' ? 'active' : ''}/>
              <button onClick={() => setColor3('#4F5358')} style={{background:'#4F5358'}} className={color3 === '#4F5358' ? 'active' : ''}/>
              <button onClick={() => setColor3('#8D9295')} style={{background:'#8D9295'}} className={color3 === '#8D9295' ? 'active' : ''}/>
              <button onClick={() => setColor3('#D7D5CB')} style={{background:'#D7D5CB'}} className={color3 === '#D7D5CB' ? 'active' : ''}/>
              <button onClick={() => setColor3('#F1F0EA')} style={{background:'#F1F0EA'}} className={color3 === '#F1F0EA' ? 'active' : ''}/>
            </div>
          </div>
          <div className='dropdown'>
            <div className='dropdown-top'>
              <div className='left-group'>
                <span style={{background:color4}}/>
                <div>
                  UPHOLSTERY
                </div>
              </div>
              <img src={(activePanel === 4) ? 'at.png' : 'ad.png'} onClick={() => setActivePanel(activePanel !== 4 ? 4 : 0)}/>
            </div>
            <div className={`dropdown-items ${(activePanel === 4) ? 'active' : ''}`}>
              <button onClick={() => setColor4('#0E0E10')} style={{background:'#0E0E10'}} className={color4 === '#0E0E10' ? 'active' : ''}/>
              <button onClick={() => setColor4('#2F3234')} style={{background:'#2F3234'}} className={color4 === '#2F3234' ? 'active' : ''}/>
              <button onClick={() => setColor4('#4F5358')} style={{background:'#4F5358'}} className={color4 === '#4F5358' ? 'active' : ''}/>
              <button onClick={() => setColor4('#8D9295')} style={{background:'#8D9295'}} className={color4 === '#8D9295' ? 'active' : ''}/>
              <button onClick={() => setColor4('#D7D5CB')} style={{background:'#D7D5CB'}} className={color4 === '#D7D5CB' ? 'active' : ''}/>
              <button onClick={() => setColor4('#F1F0EA')} style={{background:'#F1F0EA'}} className={color4 === '#F1F0EA' ? 'active' : ''}/>
            </div>
          </div>
          <div className='dropdown'>
            <div className='dropdown-top'>
              <div className='left-group'>
                <span style={{background:color5}}/>
                <div>
                  UPHOLSTERY PRIMARY LINING
                </div>
              </div>
              <img src={(activePanel === 5) ? 'at.png' : 'ad.png'} onClick={() => setActivePanel(activePanel !== 5 ? 5 : 0)}/>
            </div>
            <div className={`dropdown-items ${(activePanel === 5) ? 'active' : ''}`}>
              <button onClick={() => setColor5('#F1DD38')} style={{background:'#F1DD38'}} className={color5 === '#F1DD38' ? 'active' : ''}/>
              <button onClick={() => setColor5('#FFB200')} style={{background:'#FFB200'}} className={color5 === '#FFB200' ? 'active' : ''}/>
              <button onClick={() => setColor5('#FF4D06')} style={{background:'#FF4D06'}} className={color5 === '#FF4D06' ? 'FF4D06' : ''}/>
              <button onClick={() => setColor5('#FF2A1B')} style={{background:'#FF2A1B'}} className={color5 === '#FF2A1B' ? 'active' : ''}/>
              <button onClick={() => setColor5('#BC4077')} style={{background:'#BC4077'}} className={color5 === '#BC4077' ? 'active' : ''}/>
              <button onClick={() => setColor5('#903373')} style={{background:'#903373'}} className={color5 === '#903373' ? 'active' : ''}/>
              <button onClick={() => setColor5('#00B51A')} style={{background:'#00B51A'}} className={color5 === '#00B51A' ? 'active' : ''}/>
              <button onClick={() => setColor5('#7EBAB5')} style={{background:'#7EBAB5'}} className={color5 === '#7EBAB5' ? 'active' : ''}/>
              <button onClick={() => setColor5('#0089B6')} style={{background:'#0089B6'}} className={color5 === '#0089B6' ? 'active' : ''}/>
              <button onClick={() => setColor5('#6093AC')} style={{background:'#6093AC'}} className={color5 === '#6093AC' ? 'active' : ''}/>
              <button onClick={() => setColor5('#21697C')} style={{background:'#21697C'}} className={color5 === '#21697C' ? 'active' : ''}/>
              <button onClick={() => setColor5('#222D5A')} style={{background:'#222D5A'}} className={color5 === '#222D5A' ? 'active' : ''}/>
              <button onClick={() => setColor5('#0E0E10')} style={{background:'#0E0E10'}} className={color5 === '#0E0E10' ? 'active' : ''}/>
              <button onClick={() => setColor5('#2F3234')} style={{background:'#2F3234'}} className={color5 === '#2F3234' ? 'active' : ''}/>
              <button onClick={() => setColor5('#4F5358')} style={{background:'#4F5358'}} className={color5 === '#4F5358' ? 'active' : ''}/>
              <button onClick={() => setColor5('#8D9295')} style={{background:'#8D9295'}} className={color5 === '#8D9295' ? 'active' : ''}/>
              <button onClick={() => setColor5('#D7D5CB')} style={{background:'#D7D5CB'}} className={color5 === '#D7D5CB' ? 'active' : ''}/>
              <button onClick={() => setColor5('#F1F0EA')} style={{background:'#F1F0EA'}} className={color5 === '#F1F0EA' ? 'active' : ''}/>
            </div>
          </div>
          <div className='dropdown'>
            <div className='dropdown-top'>
              <div className='left-group'>
                <span style={{background:color6}}/>
                <div>
                  UPHOLSTERY SECONDARY LINING
                </div>
              </div>
              <img src={(activePanel === 6) ? 'at.png' : 'ad.png'} onClick={() => setActivePanel(activePanel !== 6 ? 6 : 0)}/>
            </div>
            <div className={`dropdown-items ${(activePanel === 6) ? 'active' : ''}`}>
              <button onClick={() => setColor6('#F1DD38')} style={{background:'#F1DD38'}} className={color6 === '#F1DD38' ? 'active' : ''}/>
              <button onClick={() => setColor6('#FFB200')} style={{background:'#FFB200'}} className={color6 === '#FFB200' ? 'active' : ''}/>
              <button onClick={() => setColor6('#FF4D06')} style={{background:'#FF4D06'}} className={color6 === '#FF4D06' ? 'FF4D06' : ''}/>
              <button onClick={() => setColor6('#FF2A1B')} style={{background:'#FF2A1B'}} className={color6 === '#FF2A1B' ? 'active' : ''}/>
              <button onClick={() => setColor6('#BC4077')} style={{background:'#BC4077'}} className={color6 === '#BC4077' ? 'active' : ''}/>
              <button onClick={() => setColor6('#903373')} style={{background:'#903373'}} className={color6 === '#903373' ? 'active' : ''}/>
              <button onClick={() => setColor6('#00B51A')} style={{background:'#00B51A'}} className={color6 === '#00B51A' ? 'active' : ''}/>
              <button onClick={() => setColor6('#7EBAB5')} style={{background:'#7EBAB5'}} className={color6 === '#7EBAB5' ? 'active' : ''}/>
              <button onClick={() => setColor6('#0089B6')} style={{background:'#0089B6'}} className={color6 === '#0089B6' ? 'active' : ''}/>
              <button onClick={() => setColor6('#6093AC')} style={{background:'#6093AC'}} className={color6 === '#6093AC' ? 'active' : ''}/>
              <button onClick={() => setColor6('#21697C')} style={{background:'#21697C'}} className={color6 === '#21697C' ? 'active' : ''}/>
              <button onClick={() => setColor6('#222D5A')} style={{background:'#222D5A'}} className={color6 === '#222D5A' ? 'active' : ''}/>
              <button onClick={() => setColor6('#0E0E10')} style={{background:'#0E0E10'}} className={color6 === '#0E0E10' ? 'active' : ''}/>
              <button onClick={() => setColor6('#2F3234')} style={{background:'#2F3234'}} className={color6 === '#2F3234' ? 'active' : ''}/>
              <button onClick={() => setColor6('#4F5358')} style={{background:'#4F5358'}} className={color6 === '#4F5358' ? 'active' : ''}/>
              <button onClick={() => setColor6('#8D9295')} style={{background:'#8D9295'}} className={color6 === '#8D9295' ? 'active' : ''}/>
              <button onClick={() => setColor6('#D7D5CB')} style={{background:'#D7D5CB'}} className={color6 === '#D7D5CB' ? 'active' : ''}/>
              <button onClick={() => setColor6('#F1F0EA')} style={{background:'#F1F0EA'}} className={color6 === '#F1F0EA' ? 'active' : ''}/>
            </div>
          </div>
          <div className='dropdown'>
            <div className='dropdown-top'>
              <div className='left-group'>
                <span style={{background:color7}}/>
                <div>
                  FLOOR
                </div>
              </div>
              <img src={(activePanel === 7) ? 'at.png' : 'ad.png'} onClick={() => setActivePanel(activePanel !== 7 ? 7 : 0)}/>
            </div>
            <div className={`dropdown-items-2 ${(activePanel === 7) ? 'active' : ''}`}>
              <button onClick={() => setColor7('#9e7c59')} style={{background:'#9e7c59'}} className={color7 === '#9e7c59' ? 'active' : ''}>
                <img src='wood.avif'/>
              </button>
              <button onClick={() => setColor7('#331a00')} style={{background:'#331a00'}} className={color7 === '#331a00' ? 'active' : ''}>
                <img src='wood2.png'/>
              </button>
              <button onClick={() => setColor7('#0E0E10')} style={{background:'#0E0E10'}} className={color7 === '#0E0E10' ? 'active' : ''}/>
              <button onClick={() => setColor7('#F1F0EA')} style={{background:'#F1F0EA'}} className={color7 === '#F1F0EA' ? 'active' : ''}/>
            </div>
          </div>
          <div className='checkbox-div'>
            <div className='panel-checkbox-label'>
              <div class="checkbox-wrapper">
                <input id="_checkbox-26" type="checkbox" checked={fridge === 1}  onChange={handleFridgeChange}/>
                <label for="_checkbox-26">
                  <div class="tick_mark"></div>
                </label>
              </div>
            </div>
            <div className='panel-checkbox-div'>
              BIMINI TOP
            </div>
          </div>
          <div className='checkbox-div'>
            <div className='panel-checkbox-label'>
              <div class="checkbox-wrapper">
                <input id="_checkbox-27" type="checkbox" checked={backAdd === 1}  onChange={handleWaterSkiChange}/>
                <label for="_checkbox-27">
                  <div class="tick_mark"></div>
                </label>
              </div>
            </div>
            <div className='panel-checkbox-div'>
              WATER SKI CONSTRUCTION
            </div>
          </div>
          <div className='checkbox-div'>
            <div className='panel-checkbox-label'>
              <div class="checkbox-wrapper">
                <input id="_checkbox-28" type="checkbox" checked={backAdd === 2}  onChange={handleTableChange}/>
                <label for="_checkbox-28">
                  <div class="tick_mark"></div>
                </label>
              </div>
            </div>
            <div className='panel-checkbox-div'>
              TABLE
            </div>
          </div>
        </div>
        <div className='bottom-buttons'>
          <button onMouseEnter={() => setIsHovered(2)} onMouseLeave={() => setIsHovered(0)} onClick={() => setForm(1)}>
            <span>INQUIRY</span>
            <img src={(isHovered === 2) ? 'letter-b.png' : 'letter-w.png'}/>
          </button>
        </div>
      </div>
    </div>

    {form !== 0 &&(
      <div className='backGround-panel'>
        <div className='contact-panel'>
          <div className='contact-top'>
          <div className='contact-close'>
            <img src="close-b.png" style={{position: 'relative', height:'100%', width:'auto'}} onClick={() => setForm(0)}/>
          </div>
          </div>
          <div className='contact-form1'>
            <form className="contact-form" ref={formRef}>
              <input
                type="text"
                name="firstName"
                placeholder='NAME'
                value={formData.firstName}
                onChange={handleChange}
                required
                className="input-field"
              />
              <input
                type="email"
                name="email"
                placeholder="E-MAIL"
                value={formData.email}
                onChange={handleChange}
                required
                className="input-field"
              />
              <input
                type="text"
                name="phoneNumber"
                placeholder="PHONE NUMBER"
                value={formData.phoneNumber}
                onChange={handleChange}
                className="input-field"
              />
              <textarea
                name="message"
                rows='4'
                placeholder="MESSAGE"
                value={formData.message}
                onChange={handleChange}
                className="textarea-field"
              >
              </textarea>         
            </form>
            <button 
              style={{
                position:'relative',
                marginTop: '0%',
                marginBottom: '1.5%',
                marginRight: '0%',
                aspectRatio: '8/1',
                width: '80%',
                border: '0px solid #555',
                fontWeight: 'bold',
                fontSize: 'medium',
                borderRadius: '10px',
                backgroundColor: '#555',
                color: '#ffffff',
                cursor: 'pointer',
                transition: 'background 0.3s ease-in-out, color 0.3s ease-in-out',
                backgroundImage: 'url(17.png)',  // ścieżka do obrazka
              }}
              onMouseEnter={(e) => {
              
                e.target.style.backgroundColor = 'transparent',
                e.target.style.color = '#555';
                e.target.style.border = '1.5px solid #555';
                e.target.style.backgroundImage = 'url(14.png)'
            
                }}
                onMouseLeave={(e) => {
                    
                        e.target.style.backgroundColor = '#555',
                        e.target.style.color = '#fff';
                        e.target.style.border = '0px solid #555';
                        e.target.style.backgroundImage = 'url(16.png)'
                    
                }}
              >
                WYŚLIJ
          </button>
          </div>  
        </div>
      </div>
      )}
    </>
  )
}
